import { RocePoint } from "./productrocechart.datasource";

export class DecisionAllProductsRoceChartDatasource {
  rocePoints: RocePoint[];

  isoRoceTitle: string;
  isoRoce: string;
  isoRoceXAxisLabel: string;
  isoRoceYAxisLabel: string;
}
